














































import Vue from 'vue'
import BaseImage from '@/common/components/BaseImage.vue'
import { TOP_PAGE_FEATURED } from '@/top/config/const'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
//@ts-ignore
import Swiper from 'swiper/dist/js/swiper.min.js'

const MOBILE_BREAKPOINT = 768

export default Vue.extend({
  name: 'TopPageFeatured',
  components: {
    BaseImage
  },
  data() {
    return {
      swiper: undefined
    }
  },
  computed: {
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.TOP_FEATURED_CARD
    },
    featuredItems(): { [key: string]: string }[] {
      return TOP_PAGE_FEATURED
    },
    isMobileView(): boolean {
      return window.innerWidth <= MOBILE_BREAKPOINT
    }
  },
  mounted() {
    if (this.isMobileView) {
      this.swiper = new Swiper('.tp-Featured_Main', {
        spaceBetween: 24,
        pagination: false,
        slidesPerView: 1.2,
        lazy: {
          loadPrevNext: false
        }
      })
    }
  }
})
